import { useEffect, useMemo } from 'react'
import { BehaviorSubject, of } from 'rxjs'
import { delay, switchMap } from 'rxjs/operators'
import { useObservableValue, useSubject } from './rx-hooks'

/**
 * Hook that delays flipping to `true` for subsequent loads.
 * This is useful to prevent loaders from displaying if the
 * reload finishes quickly.
 *
 * @param isLoading
 * @param ms
 */
export function useLoading(isLoading: boolean, ms = 200) {
  const isLoading$ = useSubject(() => new BehaviorSubject(isLoading))
  useEffect(() => {
    isLoading$.next(isLoading)
  }, [isLoading$, isLoading])

  return useObservableValue(
    useMemo(
      () =>
        isLoading$.pipe(
          switchMap((loading, index) => {
            if (index === 0 || !loading) {
              return of(loading)
            }

            return of(true).pipe(delay(ms))
          }),
        ),
      [isLoading$, ms],
    ),
  )
}
